import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safeSharepoint',
})
export class SafeSharepointUrlPipe implements PipeTransform {
    private sanitizer: DomSanitizer = inject(DomSanitizer);

    transform(value: string): SafeResourceUrl | null {
        if (!value) {
            return null;
        }

        const url = new URL(value);
        if (url.protocol !== 'https:') {
            return null;
        }

        if (!/^metrumgroup(?:-my)?\.sharepoint\.com$/i.test(url.hostname)) {
            return null;
        }

        if (url.username || url.password) {
            return null; // no creds
        }

        url.hash = ''; // drop fragments

        // keep only safe query params
        const denyParamList = new Set(['redirect', 'next', 'returnUrl', 'url']);

        const qp = new URLSearchParams(url.search);

        for (const [k, v] of url.searchParams) {
            if (denyParamList.has(k)) {
                qp.delete(k, v);
            }
        }

        url.search = qp.toString() ? `?${qp}` : '';

        return this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
    }
}
